module.exports = __webpack_public_path__ + "static/img/printed-bg@t.062c1a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/printed-bg@t.png
// module id = 9PTa
// module chunks = 0